import { create } from 'zustand';
import { Category } from '../types';
import { categoryApi } from '../utils/api';

interface CategoryState {
  categories: Category[];
  isLoading: boolean;
  
  fetchCategories: () => Promise<void>;
  getCategoryById: (id: number) => Category | undefined;
}

export const useCategoryStore = create<CategoryState>((set, get) => ({
  categories: [],
  isLoading: false,

  fetchCategories: async () => {
    try {
      set({ isLoading: true });
      const response = await categoryApi.getCategories();
      
      if (response.success && response.data) {
        set({ categories: response.data, isLoading: false });
      } else {
        set({ isLoading: false });
      }
    } catch (error) {
      set({ isLoading: false });
      console.error('Failed to fetch categories:', error);
    }
  },

  getCategoryById: (id: number) => {
    const { categories } = get();
    
    const findCategory = (cats: Category[]): Category | undefined => {
      for (const cat of cats) {
        if (cat.id === id) return cat;
        if (cat.children) {
          const found = findCategory(cat.children);
          if (found) return found;
        }
      }
      return undefined;
    };
    
    return findCategory(categories);
  },
}));
